/**
 * Wave Domain Enum Constants
 */

// Wave Rule Status
export enum WaveRuleStatus {
  ENABLED = 'ENABLED',             // Enabled
  DISABLED = 'DISABLED',           // Disabled
}

export const WaveRuleStatusOptions = [
  { value: WaveRuleStatus.ENABLED, label: 'wave.ruleStatus.enabled', color: 'green' },
  { value: WaveRuleStatus.DISABLED, label: 'wave.ruleStatus.disabled', color: 'default' },
];

// Wave Execution Mode (Picking Mode)
export enum WaveExecutionMode {
  MANUAL_PICKING = 'MANUAL_PICKING',
  ORDER_PICKING = 'ORDER_PICKING',
  BATCH_PICKING = 'BATCH_PICKING',
}

export const WaveExecutionModeOptions = [
  { value: WaveExecutionMode.MANUAL_PICKING, label: 'wave.executionMode.manualPicking' },
  { value: WaveExecutionMode.ORDER_PICKING, label: 'wave.executionMode.orderPicking' },
  { value: WaveExecutionMode.BATCH_PICKING, label: 'wave.executionMode.batchPicking' },
];

// Launch Cycle
export enum LaunchCycle {
  DAILY = 'DAILY',                 // Daily
  WEEKLY = 'WEEKLY',               // Weekly
}

export const LaunchCycleOptions = [
  { value: LaunchCycle.DAILY, label: 'wave.launchCycle.daily' },
  { value: LaunchCycle.WEEKLY, label: 'wave.launchCycle.weekly' },
];

// Task Trigger Type
export enum TaskTriggerType {
  BY_ORDER_COUNT = 'BY_ORDER_COUNT',       // By Order Count
  BY_TIME_INTERVAL = 'BY_TIME_INTERVAL',   // By Time Interval
}

export const TaskTriggerTypeOptions = [
  { value: TaskTriggerType.BY_ORDER_COUNT, label: 'wave.taskTriggerType.byOrderCount' },
  { value: TaskTriggerType.BY_TIME_INTERVAL, label: 'wave.taskTriggerType.byTimeInterval' },
];

// Wave Time Reference Type
export enum WaveTimeReferenceType {
  ORDER_CREATE_TIME = 'ORDER_CREATE_TIME',   // Order Create Time
  ORDER_SYNC_TIME = 'ORDER_SYNC_TIME',       // Order Sync Time
}

export const WaveTimeReferenceTypeOptions = [
  { value: WaveTimeReferenceType.ORDER_CREATE_TIME, label: 'wave.timeReferenceType.orderCreateTime' },
  { value: WaveTimeReferenceType.ORDER_SYNC_TIME, label: 'wave.timeReferenceType.orderSyncTime' },
];

// Entry Condition Type
export enum EntryConditionType {
  ORDER_CREATE_TIME = 'ORDER_CREATE_TIME',
  CHANNEL = 'CHANNEL',
}

export const EntryConditionTypeOptions = [
  { value: EntryConditionType.ORDER_CREATE_TIME, label: 'wave.entryCondition.orderCreateTime' },
  { value: EntryConditionType.CHANNEL, label: 'wave.entryCondition.channel' },
];

// Channel Options
export enum ChannelType {
  LOTUS = 'LOTUS',
  AMAZE = 'AMAZE',
  CPXTRA_MALL = 'CPXTRA_MALL',
}

export const ChannelOptions = [
  { value: ChannelType.LOTUS, label: "Lotus's" },
  { value: ChannelType.AMAZE, label: 'Amaze' },
  { value: ChannelType.CPXTRA_MALL, label: 'Axtra Mall' },
];

// Document Type
export enum DocumentType {
  SAME_DAY = 'SAME_DAY',             // Same-day
}

export const DocumentTypeOptions = [
  { value: DocumentType.SAME_DAY, label: 'wave.documentType.sameDay' },
];

// Wave Status
export enum WaveStatus {
  CREATED = 'CREATED',                           // Created
  IN_PROGRESS = 'IN_PROGRESS',                   // In Progress
  GENERATE_COMPLETE = 'GENERATE_COMPLETE',       // Generate Complete
}

export const WaveStatusOptions = [
  { value: WaveStatus.CREATED, label: 'wave.waveStatus.created', color: 'blue' },
  { value: WaveStatus.IN_PROGRESS, label: 'wave.waveStatus.inProgress', color: 'processing' },
  { value: WaveStatus.GENERATE_COMPLETE, label: 'wave.waveStatus.generateComplete', color: 'green' },
];

// Wave Type
export enum WaveType {
  MANUAL = 'MANUAL',               // Manual
  AUTO = 'AUTO',                   // Auto
}

export const WaveTypeOptions = [
  { value: WaveType.MANUAL, label: 'wave.waveType.manual' },
  { value: WaveType.AUTO, label: 'wave.waveType.auto' },
];

// Weekday Options (for weekly launch cycle)
export const WeekdayOptions = [
  { value: 1, label: 'wave.weekday.monday' },
  { value: 2, label: 'wave.weekday.tuesday' },
  { value: 3, label: 'wave.weekday.wednesday' },
  { value: 4, label: 'wave.weekday.thursday' },
  { value: 5, label: 'wave.weekday.friday' },
  { value: 6, label: 'wave.weekday.saturday' },
  { value: 7, label: 'wave.weekday.sunday' },
];
